import { debounce } from "lodash";
import { useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form";

interface MxListObservableChangeProps {
  handleOnChangeFilter: (values: any) => void;
}
const MxListObservableChange = (props: MxListObservableChangeProps) => {
  const { subscribe } = useFormContext();
  const debouncedValues = debounce(values => {
    props.handleOnChangeFilter(values);
  }, 300);

  useEffect(() => {
    const callback = subscribe({
      formState: {
        values: true
      },
      callback: ({ values }) => {
        debouncedValues(values);
      }
    });

    return () => callback();
  }, [subscribe]);
  return null;
};

export default MxListObservableChange;
